export default __webpack_public_path__ + "static/media/imagem_maxoutsource.fcd981dd.png";